import {ChangeDetectionStrategy, Component, Input, OnInit} from "@angular/core";
import {BaseSubFormComponent} from "../../../../umbrella-common/components/base-sub-form.component";
import {AttachedQuestion, EstimateQuestion, Product} from "../../../../store/state/order.state";
import {FormGroup} from "@angular/forms";
import {EstimateQuestionsFormService} from "../estimate-questions-form.service";
import {TranslationsHelperService} from "../../../translations/translations-helper.service";
import {Observable} from "rxjs";
import {WINDOW_RESIZED$} from "../../../../app.component";
import {map} from "rxjs/operators";

@Component({
    selector: 'long-option-single-choice',
    templateUrl: './long-option-single-choice.template.html',
    styleUrls: ['./long-option-single-choice.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LongOptionSingleChoiceComponent extends BaseSubFormComponent implements OnInit {

	@Input() question: EstimateQuestion;
	@Input() product: Product;
	@Input() disabled: boolean = false;
	@Input() form: FormGroup;
	@Input() formService: EstimateQuestionsFormService;
	chosenAttachedQuestionOptionId: string;

	constructor(private translationHelper: TranslationsHelperService) {
		super(null);
	}

	ngOnInit(): void {
		this.setFormService(this.formService);
	}

	isMidScreenOrSmaller(): Observable<boolean> {
		return WINDOW_RESIZED$.asObservable().pipe(map(outerWidth => outerWidth < 760));
	}

	getFormKey(): string {
		return this.product.standard.name;
	}

	chooseOption(optionId: string) {
		this.chosenAttachedQuestionOptionId = optionId;
		if (!this.isDisabled()) {
			this.formService.answerSingleChoiceQuestion(this.question.questionId, this.product.standard.name, optionId);
		}
	}

	isSelected(optionId: string): boolean {
		return this.product.estimateQuestions && this.product.estimateQuestions.some(q => q.questionId == this.question.questionId && q.chosenOptionIds.includes(optionId));
	}

	formControlName(): string {
		return this.formService.getEstimateQuestionFormControlName(this.question.questionId, this.product.standard.name);
	}

	attachedQuestionFormControlName(attachedQuestionType: string): string {
		return this.formService.getEstimateAttachedQuestionFormControlName(this.question.questionId, this.product.standard.name, attachedQuestionType);
	}

	isDisabled(): boolean {
		return this.disabled || this.formService.getFormControl(this.getFormKey(), this.formControlName()).disabled;
	}

	trackByEstimateQuestionFn(index: number, item: any) {
		return index;
	}

	attachedQuestionVisible(attachedQuestion: AttachedQuestion, chosenOptionIds: string[], optionIds: string[]): boolean {
		return attachedQuestion.parentQuestionAnswerValue.includes(this.getQuestionPosition(chosenOptionIds, optionIds));
	}

	getQuestionPosition(chosenOptionIds: string[], optionIds: string[]): number {
		for (let i = 0; i < optionIds.length; i++) {
			if (optionIds[i] == chosenOptionIds[0]) {
				return i+1;
			}
		}
		return -1;
	}

	autoGrow(element: HTMLTextAreaElement) {
		if (element.scrollHeight > element.clientHeight) {
			element.style.height = element.scrollHeight + 'px';
		}
	}

	shouldDisableRadio(controlName: string) {
		return this.formService.getFormControl(this.getFormKey(), controlName).disabled;
	}

	translationSubject(attachedQuestionType: string): string {
		return `estimateQuestion[${this.question.questionId}][${attachedQuestionType}]`;
	}

	translationExists(attachedQuestionType: string): boolean {
		return this.translationHelper.translationExists(this.product.standard.name, this.translationSubject(attachedQuestionType), false);
	}

	getTranslationText(attachedQuestionType: string): string {
		return this.translationHelper.getTranslation(this.product.standard.name, this.translationSubject(attachedQuestionType), false);
	}

	protected iso27701HasItsOwnSubForm(): boolean {
		return true;
	}
}
